import React, { useImperativeHandle, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Checkbox, Divider, message, Modal, Skeleton } from 'antd';
import moment from 'moment';
import { useHistory, useParams } from 'react-router-dom';
import { debounce, get } from 'lodash';
import RenewalRecord, { RenewalRecordRef } from '@/components/Reservation/RenewalRecord';
import { IdrawerRef } from '@/components/CustomDrawer';
import TakeCareDrawer, {
  TakeCareDrawerRef,
} from '@/pages/roomState/takeCareOf/components/TakeCareDrawer';
import useReserveEditor from '@/pages/reservation/orderEditor/reserveEditor';
import useCheckInEditor from '@/pages/reservation/orderEditor/checkInEditor';
import useChannelOrderDetail from '@/pages/channel/channelOrder/centralReservationOrder/channelOrderDetail';
import DouyinChannelDetailDrawer from '@/pages/channel/tiktokDirect/components/DouyinChannelDetailDrawer';
import CardsDrawer from '@/components/Cards';
import useReserveExchangePortal from '@/pages/reservation/roomExchange/reserveExchange';
import useCheckInExchangePortal from '@/pages/reservation/roomExchange/checkInExchange';
import useReservePortal from '@/pages/reservation/reserve';
import useCheckInPortal from '@/pages/reservation/checkIn/checkIn';
import useCancelPortal from '@/pages/reservation/reserveCancel';
import useCheckInByReservePortal from '@/pages/reservation/checkIn/checkInByReserve';
import RenewalEntry, { RenewalModalRef } from '@/pages/reservation/extension/renewalEntry';
import useCheckOutPortal from '@/pages/reservation/checkOut';
import {
  applyCheckRoom,
  getOrderDetailBaseInfo,
  getOrderRoomInfo,
  getOtaCancelList,
  getStoreIsStartUseCard,
  updateOrderRemark,
  verificationCheckRoom,
} from '@/redux/actions/order';
import { IroomInfo } from '@/redux/reducers/order';
import {
  fetchCurrentSysTime,
  fetchGetBatchBusinessDate,
  fetchSysBusinessDateByTime,
} from '@/api/order';
import {
  DATE_TIME_FORMAT,
  MainOrderStatus,
  OccType,
  OCC_TYPE_MAP,
  SubOrderStatus,
  SUB_ORDER_STATUS_MAP,
  DATE_FORMAT,
  PriceChannel,
  PERM_CODES,
} from '@/config';
import { HistoryParams } from '@/utils/type';
import { renderIntlLabel } from '@/utils';
import { getTimeByUtcOffset } from '@/utils/intl';
import AuthBtn from '@/components/AuthBtn';
import UniteRoom from '../UniteRoom';
import SplitRoom from '../SplitRoom';
import RoomPrice from './components/RoomPrice';
import CancelOTAManagement from './components/CancelOTAManagement';
import UrgeRenewalDrawer from './components/UrgeRenewal';
import RoomInfoCard from './components/RoomInfoCard';

import style from './index.module.scss';

enum BtnType {
  UniteRoomBtn,
  SplitRoomBtn,
  Book2CheckinBtn,
}

const Room = ({
  // permissions,
  myRef,
  otaOrderMap,
  isStartUseCard,
  orderBaseInfo,
  roomInfoList,
  orderRoomInfoLoading,
  otaCancelListLoading,
  updateOrderRemarkFn,
  getOrderDetailBaseInfoFn,
  getOrderRoomInfoFn,
  getStoreIsStartUseCardFn,
  verificationCheckRoomFn,
  applyCheckRoomFn,
  getOtaCancelListFn,
}) => {
  const history = useHistory();
  const { resvNo } = useParams<HistoryParams>();

  const [allChecked, setAllChecked] = useState<boolean>(false);
  const [indeterminate, setIndeterminate] = useState<boolean>(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowsRecord, setSelectedRowsRecord] = useState<Array<IroomInfo>>([]);
  const [extendedCheckIn, setExtendedCheckIn] = useState<boolean>(false);
  // 房卡抽屉
  const [cardsDrawerVisible, setCardsDrawerVisible] = useState<boolean>(false);
  const [currentSelected, setCurrentSelected] = useState<IroomInfo>();

  const drawerRef = useRef<TakeCareDrawerRef>();

  const uniteRef = useRef<any>();
  const splitRef = useRef<any>();

  const reserveExchangePortal = useReserveExchangePortal();
  const checkInExchangePortal = useCheckInExchangePortal();
  const reservePortal = useReservePortal();
  const checkInPortal = useCheckInPortal();
  const cancelPortal = useCancelPortal();
  const checkInByReservePortal = useCheckInByReservePortal();
  const renewalModalRef = useRef<RenewalModalRef>();
  const cancelOTAModalRef = useRef<IdrawerRef>();
  const checkOutPortal = useCheckOutPortal();
  const reserveEditor = useReserveEditor();
  const checkInEditor = useCheckInEditor();
  const urgeRenewalDrawerRef = useRef<any>();
  const douyinRef = useRef<any>();
  const ChannelOrderDetailModal = useChannelOrderDetail();

  // 退房提示弹框
  const [warnVisible, setWarnVisible] = useState(false);
  const [masterRoomNo, setMasterRoomNo] = useState('');

  const initRoomData = () => {
    setAllChecked(false);
    setIndeterminate(false);
    setSelectedRowKeys([]);
    setSelectedRowsRecord([]);
    setExtendedCheckIn(false);
    getOrderDetailBaseInfoFn({ resvNo });
    getOrderRoomInfoFn({ resvNo });
    getStoreIsStartUseCardFn();
  };

  const handlePortalCallback = (isSuccess) => {
    if (isSuccess) {
      initRoomData();
    }
  };

  const showReserveExchangePortal = (recNo) => {
    if (recNo) {
      reserveExchangePortal.showDrawer({ recNo, onEnd: handlePortalCallback });
    }
  };

  const handleShowCardDrawer = (record) => {
    setCardsDrawerVisible(true);
    setCurrentSelected(record);
  };

  const handleCloseCardDrwaer = () => {
    setCardsDrawerVisible(false);
    setCurrentSelected(null);
    initRoomData();
  };

  const showCheckInExchangePortal = (recNo) => {
    if (recNo) {
      checkInExchangePortal.showDrawer({ recNo, onEnd: handlePortalCallback });
    }
  };

  const showAdditionalReservePortal = () => {
    if (resvNo) {
      reservePortal.showDrawer({ appendOrderId: resvNo, onEnd: handlePortalCallback });
    }
  };
  const handleAdditionalCheckin = () => {
    // 追加入住
    checkInPortal.showDrawer({
      mainOrderId: resvNo,
      onEnd: handlePortalCallback,
    });
  };
  const showBookEditPortal = () => {
    // 预订修改抽屉
    if (resvNo && Array.isArray(selectedRowKeys) && selectedRowKeys.length) {
      reserveEditor.showDrawer({
        recList: selectedRowKeys,
        onEnd: handlePortalCallback,
      });
    }
  };
  const showCancelPortal = () => {
    if (resvNo && Array.isArray(selectedRowKeys) && selectedRowKeys.length) {
      cancelPortal.showDrawer({
        mainOrderId: resvNo,
        recList: selectedRowKeys,
        onEnd: handlePortalCallback,
      });
    }
  };
  const showCheckInByReservePortal = async () => {
    let isCan = true;
    if (Array.isArray(selectedRowsRecord) && selectedRowsRecord.length) {
      const { checkinTime } = selectedRowsRecord[0];
      if (checkinTime) {
        const res = await fetchCurrentSysTime();
        const currentLocalDate = get(res, 'data.businessDate');
        const businessRes = await fetchSysBusinessDateByTime({
          time: getTimeByUtcOffset(checkinTime, DATE_TIME_FORMAT),
        });
        const selectedLocalDate = get(businessRes, 'data.localDate');
        // 当前时间营业日（没有时分秒）大于等于预抵、入住时间所在营业日
        isCan = selectedLocalDate && currentLocalDate >= selectedLocalDate;
      } else {
        isCan = false;
      }
    } else {
      isCan = false;
    }
    if (isCan) {
      if (orderBaseInfo && orderBaseInfo.resvStatus === MainOrderStatus.CheckinOrder) {
        // 预订转追加入住
        checkInByReservePortal.showDrawer({
          mainOrderId: resvNo,
          recList: selectedRowKeys,
          onEnd: handlePortalCallback,
        });
      } else {
        // 预订转入住
        checkInByReservePortal.showDrawer({
          mainOrderId: resvNo,
          recList: selectedRowKeys,
          onEnd: handlePortalCallback,
        });
      }
    } else {
      message.error(renderIntlLabel('order_msg_arrival_date'));
    }
  };
  const showRenewalPortal = () => {
    if (resvNo && Array.isArray(selectedRowKeys) && selectedRowKeys.length) {
      const firstId = selectedRowKeys[0];
      const firstOrderInfo = roomInfoList.find((item) => item.recNo === firstId);
      if (firstOrderInfo && firstOrderInfo.checkoutTime) {
        renewalModalRef.current.showModal({
          resvNo,
          recList: selectedRowKeys,
          onEnd: handlePortalCallback,
        });
      }
    }
  };
  // 申请查房
  const handleApplyCheckRoomDebounce = debounce(async () => {
    const notCheckInList = selectedRowsRecord?.filter(
      (item) => item.status !== SubOrderStatus.CheckIn,
    );
    const checkInList = selectedRowsRecord?.filter(
      (item) => item.status === SubOrderStatus.CheckIn,
    );
    let toCheckRoomlist = [];
    if (checkInList?.length) {
      try {
        const roomIds = checkInList?.map((item) => item.roomId);
        toCheckRoomlist = await verificationCheckRoomFn({ roomIds });
      } catch (error) {
        //
      }
    }
    if (notCheckInList?.length || toCheckRoomlist?.length) {
      Modal.error({
        title: renderIntlLabel('查房发起失败'),
        content: (
          <>
            <div style={{ marginBottom: '8px' }}>
              {renderIntlLabel('order_detail_msg_checkoutroom_fail1')}
            </div>
            {toCheckRoomlist?.length ? (
              <div style={{ marginBottom: '16px' }}>
                <div>{renderIntlLabel('order_detail_msg_checkoutroom_fail2')}</div>
                <div>{toCheckRoomlist?.join('、')}</div>
              </div>
            ) : null}
            {notCheckInList?.length ? (
              <div>
                <div>{renderIntlLabel('order_detail_msg_checkoutroom_fail3')}</div>
                <div>{notCheckInList?.map((item) => item.roomNo).join('、')}</div>
              </div>
            ) : null}
          </>
        ),
        closable: true,
        okText: renderIntlLabel('order_action_close'),
      });
      return;
    }
    applyCheckRoomFn(selectedRowKeys);
  }, 500);
  const showCheckinEditPortal = () => {
    // 入住修改抽屉
    if (resvNo && Array.isArray(selectedRowKeys) && selectedRowKeys.length) {
      checkInEditor.showDrawer({
        recList: selectedRowKeys,
        onEnd: handlePortalCallback,
      });
    }
  };
  const showChargebackManagementPortal = () => {
    cancelOTAModalRef.current.openDrawer();
    const recNos = selectedRowsRecord.map((item) => item.recNo);
    getOtaCancelListFn({ resvNo, recNos });
  };

  // 催续住催退
  const showUrgeRenewalDrawer = () => {
    if (Array.isArray(selectedRowKeys) && selectedRowKeys.length) {
      urgeRenewalDrawerRef.current.openModal(selectedRowKeys);
    }
  };

  const showCheckOutPortal = () => {
    if (Array.isArray(selectedRowsRecord) && selectedRowsRecord.length) {
      // 如果勾选的房间包含房主，并且没选的房间含有  入住中 或者 预订中
      const isExistHouseOwner = selectedRowsRecord.some((item) => item.roomMasterFlag);
      if (isExistHouseOwner) {
        // 房主房间号
        selectedRowsRecord.forEach((item) => {
          if (item.roomMasterFlag) setMasterRoomNo(item.roomNo);
        });
        const otherList = roomInfoList?.filter((item) => !selectedRowKeys.includes(item.recNo));
        if (Array.isArray(otherList) && otherList.length) {
          // 没选房间不得出现入住中、预订中
          const isCheckin = otherList.some(
            (item) =>
              item.status === SubOrderStatus.CheckIn || item.status === SubOrderStatus.Reservation,
          );
          if (isCheckin) {
            setWarnVisible(true);
            return;
          }
        }
      }
    }
    if (resvNo && Array.isArray(selectedRowKeys) && selectedRowKeys.length) {
      checkOutPortal.showDrawer({
        mainOrderId: resvNo,
        recList: selectedRowKeys,
        onEnd: handlePortalCallback,
      });
    }
  };
  const extendedCheckinRef = useRef<RenewalRecordRef>();
  const handleShowExtendedCheckinModal = (recNo) => {
    extendedCheckinRef.current.openModal(recNo);
  };
  /** 按钮权限判断 */
  // 追加预订
  const showAdditionalBook = useMemo(() => {
    // 账务状态 ≠ 已结
    if (
      (orderBaseInfo.resvStatus === MainOrderStatus.ReservationOrder ||
        orderBaseInfo.resvStatus === MainOrderStatus.CheckinOrder ||
        orderBaseInfo.resvStatus === MainOrderStatus.CancelReservationOrder ||
        orderBaseInfo.resvStatus === MainOrderStatus.CheckoutOrder) &&
      orderBaseInfo?.billStatus !== 1
    ) {
      return true;
    }
    return false;
  }, [orderBaseInfo]);
  // 追加入住
  // 订单状态 为 入住订单 或 退房订单 订单账务状态 ≠ 账务已结
  const showAdditionalCheckin = useMemo(() => {
    if (
      (orderBaseInfo.resvStatus === MainOrderStatus.CheckinOrder ||
        orderBaseInfo.resvStatus === MainOrderStatus.CheckoutOrder) &&
      orderBaseInfo?.billStatus !== 1
    ) {
      return true;
    }
    return false;
  }, [orderBaseInfo]);
  // 添加联房
  const showAdditionalUniteRoom = useMemo(() => {
    if (Array.isArray(roomInfoList) && roomInfoList.length) {
      return roomInfoList.some((item) => item.status === SubOrderStatus.CheckIn);
    }
    return false;
  }, [roomInfoList]);
  /** 表格内按钮权限 */
  const isSameAllRecords = (rowsRecordList, type?: string) => {
    let isSame = true;
    const originItem = rowsRecordList[0];
    const originCheckinTimeStr = originItem.checkinTime
      ? getTimeByUtcOffset(originItem.checkinTime, DATE_TIME_FORMAT)
      : '';
    for (let i = 1; i < rowsRecordList.length; i += 1) {
      const {
        priceChannel,
        priceStrategyName,
        channelOrderNo,
        occType,
        checkinTime,
        checkoutTime,
        occDuration,
        remark,
        checkinRemark,
      } = rowsRecordList[i];
      const checkinTimeStr = checkinTime ? getTimeByUtcOffset(checkinTime, DATE_TIME_FORMAT) : '';
      // 预订转入住
      // 所选的房间客源渠道、计价策略、渠道单号、入住类型、入住时间、入住时长、退房时间 必须都相同
      // **预订修改时预订备注需一样
      // **入住修改时入住备注需一样
      if (type === 'book' && originItem.remark !== remark) {
        isSame = false;
        break;
      }
      if (type === 'checkin' && originItem.checkinRemark !== checkinRemark) {
        isSame = false;
        break;
      }
      // 预订转入住
      if (
        originItem.priceChannel !== priceChannel ||
        originItem.priceStrategyName !== priceStrategyName ||
        originItem.channelOrderNo !== channelOrderNo ||
        originItem.occType !== occType ||
        !originCheckinTimeStr ||
        !checkinTimeStr ||
        originCheckinTimeStr !== checkinTimeStr ||
        originItem.checkoutTime !== checkoutTime ||
        originItem.occDuration !== occDuration
      ) {
        isSame = false;
        break;
      }
    }
    return isSame;
  };
  // 预订转入住
  const showBook2CheckIn = useMemo(() => {
    if (Array.isArray(selectedRowsRecord) && selectedRowsRecord.length) {
      const isAllBooker = selectedRowsRecord.every(
        (item) => item.status === SubOrderStatus.Reservation,
      );
      if (isAllBooker) {
        return isSameAllRecords(selectedRowsRecord);
      }
    }
    return false;
  }, [selectedRowsRecord]);
  // 预订修改
  const showBookEdit = useMemo(() => {
    if (Array.isArray(selectedRowsRecord) && selectedRowsRecord.length) {
      const isAllBooker = selectedRowsRecord.every(
        (item) => item.status === SubOrderStatus.Reservation,
      );
      if (isAllBooker) {
        return isSameAllRecords(selectedRowsRecord, 'book');
      }
    }
    return false;
  }, [selectedRowsRecord]);
  // 取消预订
  const showCancelBook = useMemo(() => {
    if (Array.isArray(selectedRowsRecord) && selectedRowsRecord.length) {
      return selectedRowsRecord.every((item) => item.status === SubOrderStatus.Reservation);
    }
    return false;
  }, [selectedRowsRecord]);
  // 申请查房
  const canApplyCheckRoom = useMemo(() => {
    return !!selectedRowsRecord?.length;
  }, [selectedRowsRecord]);
  // 入住修改
  const showCheckinEdit = useMemo(() => {
    if (Array.isArray(selectedRowsRecord) && selectedRowsRecord.length) {
      const isAllCheckin = selectedRowsRecord.every(
        // 不能存在续住
        (item) => item.status === SubOrderStatus.CheckIn && !item.extensionFlag,
      );
      if (isAllCheckin) {
        return isSameAllRecords(selectedRowsRecord, 'checkin');
      }
    }
    return false;
  }, [selectedRowsRecord]);
  // 直连退单管理
  const showChargebackManagement = useMemo(() => {
    if (Array.isArray(selectedRowsRecord) && selectedRowsRecord.length) {
      return true;
    }
    return false;
  }, [selectedRowsRecord]);

  // 催续住催退
  const showUrgeRenewal = useMemo(() => {
    // 1、必须选择房间
    // 2、房间数量不限
    // 3、所选的房间状态必须是：入住中
    // 4、所选的房间必须都超过了预离时间
    if (Array.isArray(selectedRowsRecord) && selectedRowsRecord.length) {
      const currentTime = moment();
      return selectedRowsRecord.every((item) => {
        return (
          item.status === SubOrderStatus.CheckIn && currentTime.isAfter(item.expectedDepartureTime)
        );
      });
    }
    return false;
  }, [selectedRowsRecord]);

  // 退房
  const showCheckOut = useMemo(() => {
    if (Array.isArray(selectedRowsRecord) && selectedRowsRecord.length) {
      const isAllCheckin = selectedRowsRecord.every(
        (item) => item.status === SubOrderStatus.CheckIn,
      );
      if (isAllCheckin) return true;
    }
    return false;
  }, [selectedRowsRecord, roomInfoList]);
  // 拆分联房
  const showSplitRoom = useMemo(() => {
    if (Array.isArray(selectedRowsRecord) && selectedRowsRecord.length) {
      const isExistCheckin = selectedRowsRecord.some(
        (item) => item.status === SubOrderStatus.CheckIn,
      );
      const isExistHouseOwner = selectedRowsRecord.some((item) => item.roomMasterFlag);
      let isExistOtherCheckin = false;
      const otherList = roomInfoList?.filter((item) => !selectedRowKeys.includes(item.roomId));
      if (Array.isArray(otherList) && otherList.length) {
        isExistOtherCheckin = otherList.some((item) => item.status === SubOrderStatus.CheckIn);
      }
      // 所选房间至少包含一个入住，不得包含房主所在房间
      // 没选房间至少包含一个入住中
      if (isExistCheckin && !isExistHouseOwner && isExistOtherCheckin) {
        return true;
      }
    }
    return false;
  }, [selectedRowsRecord, roomInfoList]);

  const handleClickBtn = async (type) => {
    switch (type) {
      case BtnType.UniteRoomBtn:
        uniteRef.current.onOpen();
        break;
      case BtnType.SplitRoomBtn:
        splitRef.current.onOpen();
        break;
      case BtnType.Book2CheckinBtn:
        break;
      default:
        break;
    }
  };

  // 续住
  const getExtendedCheckInState = async (selectedRows) => {
    if (Array.isArray(selectedRows) && selectedRows.length) {
      const isAllCheckin = selectedRows.every((item) => item.status === SubOrderStatus.CheckIn);
      if (isAllCheckin) {
        // 单个不用判断营业日
        if (selectedRows.length === 1) {
          return true;
        }
        try {
          const res = await fetchGetBatchBusinessDate({
            items: selectedRows?.map((item) => ({
              localDateTime: item.checkoutTime,
            })),
          });
          if (res.code === 0) {
            const dateList = res.data?.businessDateFutureItemVOS;
            let isSameDate = true;
            const currentDateStr = getTimeByUtcOffset(dateList[0].localDate, DATE_FORMAT);
            for (let i = 1; i < dateList.length; i++) {
              if (getTimeByUtcOffset(dateList[i].localDate, DATE_FORMAT) !== currentDateStr) {
                isSameDate = false;
                break;
              }
            }
            return isSameDate;
          }
        } catch (error) {
          //
        }
      }
    }
    return false;
  };

  const handleAllCheckboxChange = async (e) => {
    setIndeterminate(false);
    if (e.target.checked) {
      setAllChecked(true);
      setSelectedRowKeys(roomInfoList?.map((item) => item.recNo));
      setSelectedRowsRecord(roomInfoList);

      const showExtended = await getExtendedCheckInState(roomInfoList);
      setExtendedCheckIn(showExtended);
    } else {
      setAllChecked(false);
      setSelectedRowKeys([]);
      setSelectedRowsRecord([]);

      setExtendedCheckIn(false);
    }
  };

  const handleCheckBoxchange = async (checked, record) => {
    let keyList = Array.isArray(selectedRowKeys) ? [...selectedRowKeys] : [];
    if (checked) {
      keyList.push(record?.recNo);
    } else {
      keyList = keyList?.filter((val) => val !== record?.recNo);
    }
    const recordList = roomInfoList?.filter((item) => keyList?.includes(item.recNo));
    if (keyList?.length && keyList?.length < roomInfoList?.length) {
      setIndeterminate(true);
    } else {
      setIndeterminate(false);
    }
    setAllChecked(keyList?.length && keyList?.length === roomInfoList?.length);
    setSelectedRowKeys(keyList);
    setSelectedRowsRecord(recordList);

    const showExtended = await getExtendedCheckInState(recordList);
    setExtendedCheckIn(showExtended);
  };

  const handleSaveRoom = (data, index) => {
    const item = data[index];
    const { recNo, channelOrderNo, remark, checkinRemark } = item;
    updateOrderRemarkFn({ resvNo, recNo, channelOrderNo, remark, checkinRemark });
  };

  const handleUniteRoomCallback = (selectedMainResvNo) => {
    // 重置路由参数，主单发生变化
    if (selectedMainResvNo) {
      history.replace(`/order/room-order/${selectedMainResvNo}`);
    }
  };

  const handleCancelOta = async () => {
    const recNos = selectedRowsRecord.map((item) => item.recNo);
    getOtaCancelListFn({ resvNo, recNos });
  };

  useImperativeHandle(
    myRef,
    () => ({
      initRoomData,
    }),
    [],
  );

  // const columns: Array<IcustomColumnType<any>> = useMemo(() => {
  //   const attr: Array<IcustomColumnType<any>> = [
  //     {
  //       title: '房型',
  //       dataIndex: 'roomTypeName',
  //     },
  //     {
  //       title: '房号',
  //       dataIndex: 'roomNo',
  //       render: (val, record) =>
  //         (record.status === SubOrderStatus.Reservation ||
  //           record.status === SubOrderStatus.CancelReservation) &&
  //         !val
  //           ? '待排'
  //           : val,
  //     },
  //     {
  //       title: '状态',
  //       dataIndex: 'status',
  //       render: (val) => SUB_ORDER_STATUS_MAP[val],
  //     },
  //     {
  //       title: '客源渠道',
  //       dataIndex: 'sourceChannelName',
  //     },
  //     {
  //       title: '计价策略',
  //       dataIndex: 'priceStrategyName',
  //     },
  //     {
  //       title: '渠道单号',
  //       dataIndex: 'channelOrderNo',
  //       width: 180,
  //     },
  //     {
  //       title: '入住类型',
  //       dataIndex: 'occType',
  //       render: (val) => (val === '多种' ? '多种' : OCC_TYPE_MAP[val]),
  //     },
  //     {
  //       title: '入住时间',
  //       dataIndex: 'checkinTime',
  //       render: (val) => (val ? moment(val).format(DATE_TIME_FORMAT) : ''),
  //       width: 180,
  //     },
  //     {
  //       title: '退房时间',
  //       dataIndex: 'checkoutTime',
  //       render: (val) => (val ? moment(val).format(DATE_TIME_FORMAT) : ''),
  //       width: 180,
  //     },
  //     {
  //       title: '入住时长',
  //       dataIndex: 'occDuration',
  //       render: (val, record) => {
  //         let str = '';
  //         if (record.extensionFlag) {
  //           str = '时段';
  //         } else if (record.occType === OccType.DayUse) {
  //           str = '晚';
  //         } else if (record.occType === OccType.TimeRENT) {
  //           str = '小时';
  //         } else {
  //           str = '';
  //         }
  //         return val ? `${val}${str}` : '';
  //       },
  //     },
  //     {
  //       title: '入住人数',
  //       dataIndex: 'memCount',
  //       render: (val) => val || 0,
  //     },
  //     {
  //       title: '预订备注',
  //       dataIndex: 'remark',
  //       render: (val) => <ExpandableEllipsis content={val} />,
  //       width: 180,
  //     },
  //     {
  //       title: '入住备注',
  //       dataIndex: 'checkinRemark',
  //       render: (val) => <ExpandableEllipsis content={val} />,
  //       width: 180,
  //     },
  //     {
  //       title: '操作',
  //       render: (_, record) => (
  //         <>
  //           <div className="flex-end">
  //             {record.status === SubOrderStatus.CheckIn && isStartUseCard ? (
  //               <>
  //                 <Button type="link" onClick={() => handleShowCardDrawer(record)}>
  //                   房卡管理
  //                 </Button>
  //                 <Divider type="vertical" />
  //               </>
  //             ) : null}
  //             {record.extensionFlag ? (
  //               <>
  //                 <Button type="link" onClick={() => handleShowExtendedCheckinModal(record.recNo)}>
  //                   续住明细
  //                 </Button>
  //                 <Divider type="vertical" />
  //               </>
  //             ) : null}
  //             {record.status === SubOrderStatus.Reservation ? (
  //               <>
  //                 <Button type="link" onClick={() => showReserveExchangePortal(record.recNo)}>
  //                   预订换排房
  //                 </Button>
  //                 <Divider type="vertical" />
  //               </>
  //             ) : null}
  //             {record.status === SubOrderStatus.CheckIn ? (
  //               <>
  //                 <Button type="link" onClick={() => showCheckInExchangePortal(record.recNo)}>
  //                   入住换房
  //                 </Button>
  //               </>
  //             ) : null}
  //             {record.priceChannel === PriceChannel.CRS && !record.extensionFlag ? (
  //               <Button
  //                 type="link"
  //                 onClick={() => {
  //                   ChannelOrderDetailModal.showDrawer({
  //                     orderNo: record.channelOrderNo,
  //                   });
  //                 }}
  //               >
  //                 渠道单详情
  //               </Button>
  //             ) : null}
  //           </div>
  //         </>
  //       ),
  //       fixed: 'right',
  //       align: 'right',
  //     },
  //   ];
  //   if (isStartUseCard) {
  //     attr.splice(11, 0, {
  //       title: '房卡数量',
  //       dataIndex: 'roomCardCount',
  //     });
  //     return attr;
  //   }
  //   return attr;
  // }, [roomInfoList, isStartUseCard]);

  const renderKeyList = (detail) => {
    const list: any = [
      {
        keyItemList: [
          {
            label: renderIntlLabel('order_roomorder_tourist_source_channel'),
            key: 'sourceChannelName',
          },
          { label: renderIntlLabel('order_roomorder_pricing_strategy'), key: 'priceStrategyName' },
          {
            label: renderIntlLabel('order_roomorder_channel_bill_number'),
            key: 'channelOrderNo',
            render: (val) => val || '—',
          },
        ],
        style: { width: '20%' },
      },
      {
        keyItemList: [
          {
            label: renderIntlLabel('order_roomorder_occtype'),
            key: 'occType',
            render: (val) =>
              val === '多种' ? renderIntlLabel('app_enum_occ_type_multi') : OCC_TYPE_MAP[val],
          },
          {
            label: renderIntlLabel('order_roomorder_checkin_time'),
            key: 'checkinTime',
            render: (val) => (val ? getTimeByUtcOffset(val, DATE_TIME_FORMAT) : ''),
          },
          {
            label: renderIntlLabel('order_roomorder_checkout_time'),
            key: 'checkoutTime',
            render: (val) => (val ? getTimeByUtcOffset(val, DATE_TIME_FORMAT) : ''),
          },
          {
            label: renderIntlLabel('order_roomorder_checkin_duration_time'),
            key: 'occDuration',
            render: (val, record) => {
              let str = '';
              if (record.extensionFlag) {
                str = renderIntlLabel('app_enum_occ_type_multi_unit');
              } else if (record.occType === OccType.DayUse) {
                str = renderIntlLabel('app_enum_occ_type_day_unit');
              } else if (record.occType === OccType.TimeRENT) {
                str = renderIntlLabel('app_enum_occ_type_time_unit');
              } else {
                str = '';
              }
              return val ? `${val}${str}` : '';
            },
          },
        ],
        style: { width: '20%' },
      },
      {
        keyItemList: [
          {
            label: renderIntlLabel('order_roomorder_query_reservation_remark'),
            key: 'remark',
            render: (val) => val || '—',
            style: { display: 'block' },
            labelStyle: { marginRight: 0, marginBottom: 8 },
          },
        ],
        style: { flex: 1 },
      },
      {
        keyItemList: [
          {
            label: renderIntlLabel('order_detail_take_care'),
            key: 'advanceCareContent',
            render: (val) => val || '—',
            style: { display: 'block' },
            labelStyle: { marginRight: 0, marginBottom: 8 },
          },
        ],
        style: { flex: 1 },
      },
      {
        keyItemList: [
          {
            label: renderIntlLabel('order_roomorder_query_checkin_remark'),
            key: 'checkinRemark',
            render: (val) => val || '—',
            style: { display: 'block' },
            labelStyle: { marginRight: 0, marginBottom: 8 },
          },
        ],
        style: { flex: 1 },
      },
    ];
    if (detail.status === SubOrderStatus.CheckIn) {
      list[0].keyItemList.push({
        label: renderIntlLabel('order_roomorder_number_of_checkin_guest'),
        key: 'memCount',
        render: (val) => val || 0,
      });
    }
    if (isStartUseCard) {
      list[0].keyItemList.push({
        label: renderIntlLabel('order_roomorder_number_of_room_card'),
        key: 'roomCardCount',
        render: (val) => val || 0,
      });
    }
    return list;
  };

  return (
    <div className={style.container}>
      {/* 抖音直连渠道单详情 */}
      <DouyinChannelDetailDrawer ref={douyinRef} />
      <TakeCareDrawer ref={drawerRef} />

      {/* 续住明细 */}
      <RenewalRecord ref={extendedCheckinRef} onEnd={handlePortalCallback} />
      <UniteRoom ref={uniteRef} afterOpenChange={handleUniteRoomCallback} />
      <SplitRoom
        ref={splitRef}
        recNoList={selectedRowKeys}
        recordList={selectedRowsRecord}
        afterOpenChange={initRoomData}
      />
      <RenewalEntry ref={renewalModalRef} />
      {/* OTA退单 */}
      <CancelOTAManagement
        ref={cancelOTAModalRef}
        otaOrderMap={otaOrderMap}
        loading={otaCancelListLoading}
        onActionCallBack={handleCancelOta}
      />

      <CardsDrawer
        cardsDrawerVisible={cardsDrawerVisible}
        recNo={currentSelected?.recNo}
        checkInTime={currentSelected?.checkinTime}
        checkOutTime={currentSelected?.checkoutTime}
        roomId={currentSelected?.roomId}
        roomNo={currentSelected?.roomNo}
        closeCallBack={handleCloseCardDrwaer}
      />

      <div className="space-between" style={{ alignItems: 'flex-start' }}>
        <div className="groupLabel">{renderIntlLabel('order_frontDesk_title_room_info')}</div>
        <div className={style.groupRight}>
          <AuthBtn>
            <Button
              data-authkey={PERM_CODES.RESERVE_AGAIN}
              type="primary"
              disabled={!showAdditionalBook}
              onClick={showAdditionalReservePortal}
            >
              {renderIntlLabel('order_action_reserve_again')}
            </Button>
            <Button
              data-authkey={PERM_CODES.CHECKIN_AGAIN}
              type="primary"
              disabled={!showAdditionalCheckin}
              onClick={handleAdditionalCheckin}
            >
              {renderIntlLabel('order_action_checkin_again')}
            </Button>
            <Button
              data-authkey={PERM_CODES.JOIN_UNITE_ROOM}
              type="primary"
              disabled={!showAdditionalUniteRoom}
              onClick={() => handleClickBtn(BtnType.UniteRoomBtn)}
            >
              {renderIntlLabel('order_action_add_unite_room')}
            </Button>
          </AuthBtn>
        </div>
      </div>
      {/* 房间信息 */}
      <div className={style.group}>
        <div className={`${style.groupAction} ${style.bg}`}>
          <AuthBtn>
            <div style={{ width: 'auto' }}>
              <Checkbox
                data-authkey="noPermissionsRequired"
                checked={allChecked}
                indeterminate={indeterminate}
                onChange={handleAllCheckboxChange}
              >
                {renderIntlLabel('order_goods_fully_select')}
              </Checkbox>
            </div>
            <div className={style.selectedCount}>
              {renderIntlLabel('order_goods_has_xuanze')}
              <span>{selectedRowKeys.length}</span>
              {renderIntlLabel('order_goods_xiang')}
            </div>
            <Button
              data-authkey={PERM_CODES.RESERVE_2_CHECKIN}
              disabled={!showBook2CheckIn}
              onClick={showCheckInByReservePortal}
            >
              {renderIntlLabel('order_action_reserve_2_checkin')}
            </Button>
            <Button
              data-authkey={PERM_CODES.RESERVE_EDIT}
              disabled={!showBookEdit}
              onClick={showBookEditPortal}
            >
              {renderIntlLabel('order_action_reserve_edit')}
            </Button>
            <Button
              data-authkey={PERM_CODES.RESERVE_CANCEL}
              className={style.line}
              disabled={!showCancelBook}
              onClick={showCancelPortal}
            >
              {renderIntlLabel('order_action_reserve_cancel')}
            </Button>
            <Button
              data-authkey={PERM_CODES.EXTEDN_CHECKIN}
              disabled={!extendedCheckIn}
              onClick={showRenewalPortal}
            >
              {renderIntlLabel('order_action_extended_checkin')}
            </Button>
            <Button
              data-authkey={PERM_CODES.APPLY_CHECKOUT}
              disabled={!canApplyCheckRoom}
              onClick={handleApplyCheckRoomDebounce}
            >
              {renderIntlLabel('order_action_apply_checkout_room')}
            </Button>
            <Button
              data-authkey={PERM_CODES.CHECKIN_EDIT}
              disabled={!showCheckinEdit}
              onClick={showCheckinEditPortal}
            >
              {renderIntlLabel('order_action_checkin_edit')}
            </Button>
            <Button
              data-authkey={PERM_CODES.DIRECT_CHARGEBACK}
              disabled={!showChargebackManagement}
              onClick={showChargebackManagementPortal}
            >
              {renderIntlLabel('order_action_direct_reject_order')}
            </Button>
            <Button
              data-authkey={PERM_CODES.URGE_EXTEND_CHECKIN}
              disabled={!showUrgeRenewal}
              onClick={showUrgeRenewalDrawer}
            >
              {renderIntlLabel('order_action_urge_extend_return')}
            </Button>
            <Button
              data-authkey={PERM_CODES.CHECKOUT}
              className={style.line}
              disabled={!showCheckOut}
              onClick={showCheckOutPortal}
            >
              {renderIntlLabel('order_action_checkout')}
            </Button>
            <Button
              data-authkey={PERM_CODES.SPLIT_ROOM}
              disabled={!showSplitRoom}
              onClick={() => handleClickBtn(BtnType.SplitRoomBtn)}
            >
              {renderIntlLabel('order_action_split_unite_room')}
            </Button>
          </AuthBtn>
        </div>
        <Skeleton loading={orderRoomInfoLoading}>
          {/* <EditCellTable
            columns={columns}
            dataSource={roomInfoList}
            pagination={false}
            showRowSelection
            // onCheckBoxchange={handleCheckBoxchange}
            onSaveCellChange={handleSaveRoom}
            scroll={{ x: 'max-content' }}
          /> */}
          {roomInfoList?.map((detail) => (
            <RoomInfoCard
              key={detail?.recNo}
              title={
                <>
                  <div className={style.headerTitle}>
                    <div className={style.headerItem}>
                      <span className={style.label}>
                        {renderIntlLabel('order_roomorder_room_type')}
                      </span>
                      <span>{detail?.roomTypeName}</span>
                    </div>
                    <div className={style.headerItem}>
                      <span className={style.label}>
                        {renderIntlLabel('order_roomorder_room_number')}
                      </span>
                      <span>
                        {(detail.status === SubOrderStatus.Reservation ||
                          detail.status === SubOrderStatus.CancelReservation) &&
                        !detail?.roomNo
                          ? renderIntlLabel('order_wait_arrange')
                          : detail?.roomNo}
                      </span>
                    </div>
                    <div className={style.headerItem}>
                      <span className={style.label}>{renderIntlLabel('order_status')}</span>
                      <span>{SUB_ORDER_STATUS_MAP[detail?.status]}</span>
                    </div>
                  </div>
                </>
              }
              extra={
                <>
                  <AuthBtn>
                    <div className="flex-end">
                      {detail.advanceCareContent ? (
                        <>
                          <Button
                            data-authkey={PERM_CODES.TAKE_CARE}
                            type="link"
                            onClick={() => {
                              drawerRef.current.openDrawer({
                                recNo: detail.recNo,
                                callback() {
                                  initRoomData();
                                },
                              });
                            }}
                          >
                            {renderIntlLabel('order_detail_take_care')}
                          </Button>
                          <Divider type="vertical" />
                        </>
                      ) : null}
                      {detail.status === SubOrderStatus.CheckIn && isStartUseCard ? (
                        <>
                          <Button
                            data-authkey={PERM_CODES.ROOM_CARDS_MANAGEMENT}
                            type="link"
                            onClick={() => handleShowCardDrawer(detail)}
                          >
                            {renderIntlLabel('order_action_room_card_management')}
                          </Button>
                          <Divider type="vertical" />
                        </>
                      ) : null}
                      {detail.extensionFlag ? (
                        <>
                          <Button
                            data-authkey={PERM_CODES.EXTEDN_CHECKIN_DETAIL}
                            type="link"
                            onClick={() => handleShowExtendedCheckinModal(detail.recNo)}
                          >
                            {renderIntlLabel('order_action_extended_checkin_detail')}
                          </Button>
                          <Divider type="vertical" />
                        </>
                      ) : null}
                      {detail.status === SubOrderStatus.Reservation ? (
                        <>
                          <Button
                            data-authkey={PERM_CODES.RESERVE_ARRANGE}
                            type="link"
                            onClick={() => showReserveExchangePortal(detail.recNo)}
                          >
                            {renderIntlLabel('order_action_reserve_2_arrange_room')}
                          </Button>
                          <Divider type="vertical" />
                        </>
                      ) : null}
                      {detail.status === SubOrderStatus.CheckIn ? (
                        <>
                          <Button
                            data-authkey={PERM_CODES.CHECININ_EXCHANGE}
                            type="link"
                            onClick={() => showCheckInExchangePortal(detail.recNo)}
                          >
                            {renderIntlLabel('order_action_checkin_exchange_room')}
                          </Button>
                        </>
                      ) : null}
                      {(detail.priceChannel === PriceChannel.CRS ||
                        detail.priceChannel === PriceChannel.DY_ZL) &&
                      !detail.extensionFlag ? (
                        <Button
                          data-authkey={PERM_CODES.CHANNEL_DETAIL}
                          type="link"
                          onClick={() => {
                            if (detail.priceChannel === PriceChannel.CRS) {
                              ChannelOrderDetailModal.showDrawer({
                                orderNo: detail.channelOrderNo,
                              });
                            }
                            if (detail.priceChannel === PriceChannel.DY_ZL) {
                              douyinRef.current.openDrawer({
                                orderNo: detail.channelOrderNo,
                              });
                            }
                          }}
                        >
                          {renderIntlLabel('order_action_channel_order_detail')}
                        </Button>
                      ) : null}
                    </div>
                  </AuthBtn>
                </>
              }
              cardList={renderKeyList(detail)}
              record={detail}
              showRowSelection
              checked={selectedRowKeys?.includes(detail?.recNo)}
              onChange={handleCheckBoxchange}
            />
          ))}

          <RoomPrice />
        </Skeleton>
      </div>
      <UrgeRenewalDrawer innerRef={urgeRenewalDrawerRef} />
      <Modal
        title={renderIntlLabel('order_detail_msg_cannot_checkout_room')}
        centered
        visible={warnVisible}
        maskClosable={false}
        footer={null}
        onCancel={() => {
          setWarnVisible(false);
          setMasterRoomNo('');
        }}
        width={500}
      >
        <div>
          {renderIntlLabel('order_detail_msg_cannot_checkout_room_content1')} <b>{masterRoomNo}</b>{' '}
          {renderIntlLabel('order_detail_msg_cannot_checkout_room_content2')}
        </div>
        <div style={{ textAlign: 'right', marginTop: '20px' }}>
          <Button
            type="primary"
            onClick={() => {
              setWarnVisible(false);
              setMasterRoomNo('');
            }}
          >
            {renderIntlLabel('order_action_confirm_queding')}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { permissions } = state.user;
  return {
    ...state.order,
    permissions,
  };
};

const ConnectComponent: React.FC<any> = connect(mapStateToProps, {
  updateOrderRemarkFn: updateOrderRemark,
  getOrderDetailBaseInfoFn: getOrderDetailBaseInfo,
  getOrderRoomInfoFn: getOrderRoomInfo,
  getStoreIsStartUseCardFn: getStoreIsStartUseCard,
  verificationCheckRoomFn: verificationCheckRoom,
  applyCheckRoomFn: applyCheckRoom,
  getOtaCancelListFn: getOtaCancelList,
})(React.memo(Room));

export default React.forwardRef<any, any>((props, ref) => (
  <ConnectComponent {...props} myRef={ref} />
));
